import { SelectField } from '@eventbrite/marmalade';
import { RadioOption } from '../RadioListQuestion';
import styles from './SelectQuestion.module.scss';

interface SelectQuestionProps {
    stepName: string;
    onChange: (value: SelectedOption) => void;
    value?: number;
    options: RadioOption[];
    label?: string;
    isRequired?: boolean;
    hideIcon?: boolean;
    disabled?: boolean;
}

export interface SelectedOption {
    value: number;
    name: string;
    text: string;
}

interface Option {
    label: string;
    value: string;
}

export const SelectQuestion = ({
    stepName,
    onChange,
    value,
    options,
    label: selectFieldLabel,
    isRequired,
    hideIcon,
    disabled,
}: SelectQuestionProps) => {
    const selectOptions: Option[] = options.map((option) => {
        const label = option.text;
        const value = `${option.value}`;
        return { label, value };
    });

    const foundSelected = (option: RadioOption) => option?.value === value;
    const icon = value && options.find(foundSelected)?.icon;

    return (
        <SelectField
            id={stepName + '-select-field'}
            onChange={(valueNumber) => {
                const answer = options.find(
                    (option) => option.value === Number(valueNumber),
                ) as RadioOption;
                const { value, name, text } = answer;
                onChange({ value, name, text });
            }}
            value={value}
            options={selectOptions}
            label={selectFieldLabel || 'Question'}
            required={isRequired}
            testId={stepName + '-select-field'}
            prefix={hideIcon ? null : <div className={styles.icon}>{icon}</div>}
            disabled={disabled}
        />
    );
};
